<script>
  import Photos from '@app-components/rec_object/parts/Photos.svelte';
  import Track from '@utils/track';
  import Avatar from '@components/Avatar.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import Text from '@components/Text.svelte';
  let currentUser = getCurrentUserStore('default');

  export let group;
  export let mobile = false;
  export let hovered = false;
  export let user;

  let photos = group.recs || [];

  if (group.minified_cover_image_3x2) {
    photos.unshift({ photo: group.minified_cover_image_3x2 });
  }

  let photosMap = photos.map((r, index) => ({
    id: index,
    view_urls: {
      full_size: r.photo,
    },
    rec: {
      note: r.note,
      title: r.title
    }
  }));

  if (photosMap.length > 1) {
    photosMap.push({
      id: -1,
      view_urls: {
        full_size: `${photosMap[0].view_urls.full_size}?a=1`,
      },
    });
  }

  const handleClickEvent = function () {
    Track.spotlightListClicked({
      currentUser: currentUser,
      user: user,
      groupBase: group,
      path: location.pathname,
    });
    window.location = group.url;
  };
</script>

<style style="text/scss" lang="scss">
  .image-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    cursor: pointer;

    .group-images {
      border-radius: 12px;
      background: #f2f2f2;
      position: relative;
      overflow: hidden;

      .group-image {
        position: relative;

        img {
          border-radius: 12px;
          object-fit: cover;
          width: 404px;
          aspect-ratio: 1.502 / 1;
        }

        .group-image-see-all {
          filter: blur(3px) brightness(0.5);
        }

        .group-image-see-all-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
          color: white;
          font-size: 18px;
          font-weight: 500;

          .group-image-see-all-view-list {
            border-radius: 8px;
            background: #fff;
            color: black;
            width: 126px;
            height: 33px;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;

            &:hover {
              opacity: 0.9;
            }
          }
        }
      }

      .group-image-empty {
        background: #f9f7ff;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 410px;
        max-height: 268px;
        min-height: 268px;

        img {
          aspect-ratio: 1 / 1;
          min-height: unset;
        }
      }

      .group-items-count {
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.7);
        position: absolute;
        right: 12px;
        bottom: 12px;
        display: flex;
        padding: 4px 8px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: 500;
        color: white;
        z-index: 1;
        user-select: none;
      }
    }

    .image-note-container {
      position: absolute;
      bottom: 0px;
      padding-left: 16px;
      padding-right: 30px;
      padding-bottom: 35px;
      padding-top: 60px;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      gap: 2px;
      color: white;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%);
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);

      .image-note-container-note {
        display: flex;
        gap: 12px;
        align-items: center;

        .image-note-container-note-avatar {
          flex-shrink: 0;
        }
      }
    }
  }

  .image-container.mobile {
    .group-images {
      height: unset !important;
      max-width: unset !important;
      .group-image {
        max-width: unset !important;
        img {
          width: 100%;
          height: 268px;
        }
      }
    }
  }

  * :global(.ui-photos) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  * :global(.owl-dots) {
    margin-top: -30px !important;
  }

  * :global(.owl-dot > span) {
    background: white;
    width: 8px;
    height: 8px;
    opacity: 0.7;
  }

  * :global(.ui-photos .owl-next) {
    background: white !important;
    color: black !important;
    z-index: 1;
    padding: 10px;
  }

  * :global(.ui-photos .owl-prev) {
    background: white !important;
    color: black !important;
    z-index: 1;
  }

  * :global(.group-container-hovered .ui-photos .owl-next) {
    opacity: 1 !important;
  }

  * :global(.group-container-hovered .ui-photos .owl-prev) {
    opacity: 1 !important;
  }

  * :global(.ui-single-photo) {
    margin-top: 0px !important;
  }

  * :global(.mobile .owl-stage) {
    display: -webkit-box;
    margin-top: auto;
  }

  * :global(.mobile .owl-item) {
    margin-top: auto;
    margin-bottom: auto;
  }
</style>

<div class="image-container" class:mobile={mobile}>
  <div class="group-images" class:group-container-hovered={hovered}>
    <Photos
      mobile={mobile}
      extraIdentifier="group-{group.id}"
      preventDefaultClick={true}
      useFancyBox={false}
      spotlightUser={user}
      pinnedGroup={group}
      viewContext={'spotlight-list-carousel'}
      photos={photosMap}>
      <div class="group-image" slot="img" let:photo let:index>
        {#if photo.id == -1}
          <img
            class="group-image-see-all"
            src={photo.view_urls.full_size}
            on:click|preventDefault|stopPropagation={handleClickEvent} />
          <div class="image-subtle-overlay"></div>
          <div class="group-image-see-all-container">
            <div>See all {group.items_count} {group.items_count == 1 ? 'rec' : 'recs'}</div>
            <div class="group-image-see-all-view-list" on:click|preventDefault|stopPropagation={handleClickEvent}>
              View list
            </div>
          </div>
        {:else}
          <div class="image-container">
            <img
              src={photo.view_urls.full_size}
              on:click|preventDefault|stopPropagation={handleClickEvent} />

            {#if photo.rec && photo.rec.note && photo.rec.note != ''}
              <div
                class="image-note-container"
                on:click|preventDefault|stopPropagation={handleClickEvent}>
                <Text lines={1} style="font-size: 18px; font-weight: 500;" expand={false} text={photo.rec.title} />

                <div class="image-note-container-note">
                  <div class="image-note-container-note-avatar">
                    <Avatar width={32} height={32} src={group.users[0].avatar_url} user={group.users[0]} showSpotlightRingOnly={group.users[0].spotlight_active} mobile={mobile} />
                  </div>
                  <Text lines={2} style="font-size: 14px; font-weight: 500; line-height: 20px;" expand={false} text={photo.rec.note} />
                </div>
              </div>
            {/if}
            <div class="image-subtle-overlay radius-12"></div>
          </div>
        {/if}

        {#if index == 0}
          <div class="group-items-count">{group.items_count} {group.items_count == 1 ? 'rec' : 'recs'}</div>
        {/if}
      </div>
    </Photos>
    {#if photosMap.length === 0}
      <div class="group-image group-image-empty" on:click|preventDefault|stopPropagation={handleClickEvent}>
        <img src="/emojis/purple_star.png" alt="star emoji" style="width: 48px; height: 48px;" />
        <div class="group-items-count">{group.items_count} {group.items_count == 1 ? 'rec' : 'recs'}</div>
      </div>
    {/if}
  </div>
</div>
